import { api } from './request'
import orders from './order'
import payment from './payment'
import stats from './stats'
import settlement from './settlement'
import farmChange from './farmChange'

// 认证相关 API
const auth = {
  login: (username, password) => api.post('/auth/login', { username, password }),
  logout: () => api.post('/auth/logout'),
  check: () => api.get('/auth/check'),
  info: () => api.get('/auth/info'),
  updateProfile: (data) => api.put('/auth/profile', data),
  changePassword: (data) => api.post('/auth/change-password', data)
}

// 土地管理API
const lands = {
  list: (params) => api.get('/admin/lands', { params }),
  get: (id) => api.get(`/admin/lands/${id}`),
  create: (data) => api.post('/admin/lands', data),
  update: (id, data) => api.put(`/admin/lands/${id}`, data),
  delete: (id) => api.delete(`/admin/lands/${id}`),
  // 认养关联
  adoptions: (id, params) => api.get(`/admin/lands/${id}/adoptions`, { params }),
  adoptionStats: (id) => api.get(`/admin/lands/${id}/adoptions/stats`)
}

// 禽畜管理API
const livestocks = {
  list: (params) => api.get('/admin/livestocks', { params }),
  get: (id) => api.get(`/admin/livestocks/${id}`),
  create: (data) => api.post('/admin/livestocks', data),
  update: (id, data) => api.put(`/admin/livestocks/${id}`, data),
  delete: (id) => api.delete(`/admin/livestocks/${id}`),
  // 认养关联
  adoptions: (id, params) => api.get(`/admin/livestocks/${id}/adoptions`, { params }),
  adoptionStats: (id) => api.get(`/admin/livestocks/${id}/adoptions/stats`)
}

// 文章管理API
const articles = {
  list: (params) => api.get('/admin/articles', { params }),
  get: (id) => api.get(`/admin/articles/${id}`),
  create: (data) => api.post('/admin/articles', data),
  update: (id, data) => api.put(`/admin/articles/${id}`, data),
  delete: (id) => api.delete(`/admin/articles/${id}`)
}

// 农场管理API
const farms = {
  list: (params) => api.get('/admin/farms', { params }),
  get: (id) => api.get(`/admin/farms/${id}`),
  create: (data) => api.post('/admin/farms', data),
  update: (id, data) => api.put(`/admin/farms/${id}`, data),
  delete: (id) => api.delete(`/admin/farms/${id}`),
  // 农场关联商品管理
  getLivestocks: (farmId, params) => api.get(`/admin/farms/${farmId}/livestocks`, { params }),
  getProducts: (farmId, params) => api.get(`/admin/farms/${farmId}/products`, { params }),
  // 审核农场商品
  auditLivestock: (farmId, itemId, data) => api.put(`/admin/farms/${farmId}/livestocks/${itemId}/audit`, data),
  auditProduct: (farmId, itemId, data) => api.put(`/admin/farms/${farmId}/products/${itemId}/audit`, data),
  // 调整排序
  updateLivestockSort: (farmId, itemId, data) => api.put(`/admin/farms/${farmId}/livestocks/${itemId}/sort`, data),
  updateProductSort: (farmId, itemId, data) => api.put(`/admin/farms/${farmId}/products/${itemId}/sort`, data)
}

// 用户管理API
const users = {
  list: (params) => api.get('/admin/users', { params }),
  get: (id) => api.get(`/admin/users/${id}`),
  create: (data) => api.post('/admin/users', data),
  update: (id, data) => api.put(`/admin/users/${id}`, data),
  delete: (id) => api.delete(`/admin/users/${id}`)
}

// 应用管理API
const applications = {
  list: (params) => api.get('/admin/applications', { params }),
  get: (id) => api.get(`/admin/applications/${id}`),
  create: (data) => api.post('/admin/applications', data),
  update: (id, data) => api.put(`/admin/applications/${id}`, data),
  delete: (id) => api.delete(`/admin/applications/${id}`)
}

// Banner 管理 API（新版轮播图）
const banners = {
  list: (params) => api.get('/system/banners', { params }),
  get: (id) => api.get(`/system/banners/${id}`),
  create: (data) => api.post('/system/banners', data),
  update: (id, data) => api.put(`/system/banners/${id}`, data),
  delete: (id) => api.delete(`/system/banners/${id}`)
}

// 地址管理 API（小程序端 - 用户自己的地址）
const addresses = {
  list: (params) => api.get('/api/addresses', { params }),
  get: (id) => api.get(`/api/addresses/${id}`),
  create: (data) => api.post('/api/addresses', data),
  update: (id, data) => api.put(`/api/addresses/${id}`, data),
  delete: (id) => api.delete(`/api/addresses/${id}`),
  setDefault: (id) => api.post(`/api/addresses/${id}/set-default`)
}

// 管理员地址管理 API
const adminAddresses = {
  list: (params) => api.get('/admin/addresses', { params }),
  get: (id) => api.get(`/admin/addresses/${id}`),
  update: (id, data) => api.put(`/admin/addresses/${id}`, data),
  delete: (id) => api.delete(`/admin/addresses/${id}`)
}


// 商品管理 API
const products = {
  list: (params) => api.get('/api/products', { params }),
  get: (id) => api.get(`/api/products/${id}`),
  create: (data) => api.post('/api/products', data),
  update: (id, data) => api.put(`/api/products/${id}`, data),
  delete: (id) => api.delete(`/api/products/${id}`),
  updateStatus: (id, data) => api.put(`/api/products/${id}`, data),
  // 后台管理 API
  adminList: (params) => api.get('/admin/products', { params }),
  adminGet: (id) => api.get(`/admin/products/${id}`),
  adminCreate: (data) => api.post('/admin/products', data),
  adminUpdate: (id, data) => api.put(`/admin/products/${id}`, data),
  adminDelete: (id) => api.delete(`/admin/products/${id}`),
  categories: () => api.get('/admin/products/categories'),
  brands: () => api.get('/admin/products/brands')
}

// 订单管理 API - 从 order.js 导入

// 小程序 API
const publicApi = {
  dashboard: () => api.get('/api/dashboard'),
  lands: (params) => api.get('/api/lands', { params }),
  landDetail: (id) => api.get(`/api/lands/${id}`),
  livestocks: (params) => api.get('/api/livestocks', { params }),
  livestockDetail: (id) => api.get(`/api/livestocks/${id}`),
  articles: (params) => api.get('/api/articles', { params }),
  articleDetail: (id) => api.get(`/api/articles/${id}`)
}

// 上传图片
const uploadImage = (formData, config = {}) => {
  // 调试日志
  console.log('上传图片请求配置:', {
    url: '/admin/upload',
    hasFormData: !!formData,
    formDataKeys: formData ? Array.from(formData.keys()) : [],
    headers: config.headers || {},
    withCredentials: api.defaults.withCredentials
  });

  // 检查FormData内容
  if (formData && formData.get('file')) {
    const file = formData.get('file');
    console.log('文件信息:', {
      name: file.name,
      type: file.type,
      size: file.size
    });
  }

  return api.post('/admin/upload', formData, config)
};

// 上传轮播图图片
const uploadBanner = (formData, config = {}) => {
  return api.post('/api/upload/banner', formData, config)
};

// 系统设置管理 API
const settings = {
  getAll: () => api.get('/system/settings'),
  update: (data) => api.post('/system/settings', data),
  getByKey: (key) => api.get(`/system/settings/${key}`),
  updateByKey: (key, data) => api.put(`/system/settings/${key}`, data)
}

// 首页简介管理 API
const homeIntro = {
  get: () => api.get('/system/home-intro'),
  update: (data) => api.put('/system/home-intro', data)
}

// 帮助中心文章管理 API
const helpArticles = {
  list: (params) => api.get('/system/help-articles', { params }),
  get: (id) => api.get(`/system/help-articles/${id}`),
  create: (data) => api.post('/system/help-articles', data),
  update: (id, data) => api.put(`/system/help-articles/${id}`, data),
  delete: (id) => api.delete(`/system/help-articles/${id}`)
}

// 操作日志 API
const logs = {
  adminLogs: (params) => api.get('/admin/logs/admin', { params }),
  adminLogActions: () => api.get('/admin/logs/admin/actions'),
  adminLogTargetTypes: () => api.get('/admin/logs/admin/target-types')
}

// 活动管理 API
const activities = {
  list: (params) => api.get('/admin/activities', { params }),
  get: (id) => api.get(`/admin/activities/${id}`),
  create: (data) => api.post('/admin/activities', data),
  update: (id, data) => api.put(`/admin/activities/${id}`, data),
  delete: (id) => api.delete(`/admin/activities/${id}`)
}

// 认养管理 API
const adoptions = {
  list: (params) => api.get('/admin/adoptions', { params }),
  updateStatus: (id, data) => api.put(`/admin/adoptions/${id}/status`, data),
  export: (params) => api.get('/admin/adoptions/export', { params, responseType: 'blob' }),
  // 生长记录
  growthRecords: (adoptionId) => api.get(`/api/adoptions/${adoptionId}/growth`),
  addGrowth: (adoptionId, formData) => api.post(`/api/adoptions/${adoptionId}/growth`, formData),
  deleteGrowth: (adoptionId, recordId) => api.delete(`/api/adoptions/${adoptionId}/growth/${recordId}`)
}

// 商品审核统计 API
const pendingReviews = {
  count: () => api.get('/admin/pending-reviews/count')
}

export { api }

export default {
  auth,
  lands,
  livestocks,
  articles,
  banners,
  products,
  orders,
  payment,
  farmChange,
  publicApi,
  uploadImage,
  uploadBanner,
  addresses,
  adminAddresses,
  farms,
  users,
  applications,
  settlement,
  stats,
  settings,
  homeIntro,
  helpArticles,
  logs,
  activities,
  adoptions,
  pendingReviews
}

